import { APICore } from './apiCore'

const api = new APICore()

function getFavOrigins (params) {
  const baseUrl = '/fav-origins'
  return api.get(baseUrl, params)
}

function getFavOrigin (id) {
  const baseUrl = `/fav-origins/${id}`
  return api.get(baseUrl, {})
}

function addFavOrigin (params) {
  const baseUrl = '/fav-origins'
  return api.create(baseUrl, params)
}

function updateFavOrigin (params) {
  const baseUrl = '/fav-origins'
  return api.update(baseUrl, params)
}

function deleteFavOrigin (params) {
  const baseUrl = '/fav-origins'
  return api.delete(baseUrl, params)
}

export { getFavOrigins, getFavOrigin, addFavOrigin, updateFavOrigin, deleteFavOrigin }
